function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "LOGO_FLIT",
  "data-name": "LOGO FLIT",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_3",
  "data-name": "Trazado 3",
  d: "M5138,439.005h-25.042V410.458a2.773,2.773,0,0,0-2.982-2.5h-50.708a2.775,2.775,0,0,0-2.984,2.5v31.1a2.775,2.775,0,0,0,2.984,2.5h2.748a2.773,2.773,0,0,0,2.982-2.5V428.639h18.688a2.539,2.539,0,1,0,0-5h-18.688V412.957h39.248v28.6a2.773,2.773,0,0,0,2.984,2.5H5138a2.775,2.775,0,0,0,2.984-2.5v-.052A2.775,2.775,0,0,0,5138,439.005Z",
  transform: "translate(-5056.279 -397.79)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_4",
  "data-name": "Trazado 4",
  d: "M5572.272,407.958h-55.5a2.773,2.773,0,0,0-2.983,2.5v31.1a2.773,2.773,0,0,0,2.983,2.5h2.748a2.774,2.774,0,0,0,2.982-2.5V413.01h26.141v28.548a2.773,2.773,0,0,0,2.981,2.5h2.748a2.774,2.774,0,0,0,2.983-2.5V413.01h14.913a2.774,2.774,0,0,0,2.983-2.5v-.052A2.774,2.774,0,0,0,5572.272,407.958Z",
  transform: "translate(-5422.733 -397.79)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_5",
  "data-name": "Trazado 5",
  d: "M5515.029,374.148h15.7a2.672,2.672,0,1,0,0-5.262h-15.7a2.673,2.673,0,1,0,0,5.262Z",
  transform: "translate(-5420.772 -368.886)",
  fill: "#fff"
}));

var SvgLogoflit = function SvgLogoflit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152.523,
    height: 46.267,
    viewBox: "0 0 152.523 46.267",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoflit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LOGO FLIT.8d152bc5.svg";
export { ForwardRef as ReactComponent };